import { next, type MiddlewareContext } from "~/lib/middleware/middleware";
import { type RequiredAuthenticatedUser } from "~/services/auth/fetchAuthenticatedUser";

export const fetchCompanyRolePermissions = async (ctx: MiddlewareContext<{ user: RequiredAuthenticatedUser }>) => {
  const rolePermissions = await ctx.req.prisma.rolePermissions.findMany({
    where: {
      companyId: ctx.user.companyId,
    },
  });
  return next({ user: ctx.user, companyRolePermissions: rolePermissions });
};
